import { GRUPO_CBO_ACS, NIVEL_SUPERIOR, NIVEL_TECNICO } from 'types/NivelCbo'

export const grupoCboHistorico = {
  visualizar: [...NIVEL_SUPERIOR, ...NIVEL_TECNICO],
}

export const grupoCboVacinacao = {
  visualizar: GRUPO_CBO_ACS,
}
